import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { Image } from './OptimizedImage';
import { colors } from '../../utils/colors';

interface AvatarProps {
  uri?: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  style?: ViewStyle;
}

const sizes = {
  small: 32,
  medium: 40,
  large: 48,
  xlarge: 64,
};

export const Avatar: React.FC<AvatarProps> = ({ uri, size = 'medium', style }) => {
  const avatarSize = sizes[size];

  return (
    <View
      style={[
        styles.container,
        { width: avatarSize, height: avatarSize, borderRadius: avatarSize / 2 },
        style,
      ]}
    >
      {uri ? (
        <Image
          source={{ uri }}
          style={{
            width: avatarSize, 
            height: avatarSize, 
            borderRadius: avatarSize / 2,
          }}
          contentFit="cover"
          transition={200}
        />
      ) : (
        <View
          style={[
            styles.placeholder,
            { width: avatarSize, height: avatarSize, borderRadius: avatarSize / 2 },
          ]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
  },
  image: {
    resizeMode: 'cover',
  },
  placeholder: {
    backgroundColor: colors.backgroundTertiary,
  },
});
